module.exports = __webpack_public_path__ + "media/images/team/BrunaPaulino-ae7d689764f0758fb95a070ac18e26f9.png";